import { motion } from "framer-motion";
import { IMAGES } from "@/lib/site-data";
import { SectionHeading } from "@/components/SectionHeading";

const STATS = [
  { value: "35+", label: "Jahre Berufserfahrung" },
  { value: "2", label: "Generationen – Vater & Sohn" },
  { value: "1.400", label: "realisierte Projekte" },
  { value: "5 J.", label: "Garantie auf Montage" },
];

export const About = () => (
  <section id="ueber-uns" data-testid="about-section" className="bg-[#f6f5f2] py-24 sm:py-32 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
        <div>
          <SectionHeading
            testid="about"
            eyebrow="Über uns"
            title="Handwerk, das man anfassen kann."
            text="Ringel Fenstertechnik ist ein Familienbetrieb in zweiter Generation – Vater und Sohn, mit über 35 Jahren Berufserfahrung unter Inhaber Andreas Ringel. Wir beraten, messen auf, liefern und montieren – alles aus einer Hand, ohne Subunternehmer. Unsere Leute bleiben anonym im Bild, aber nie in der Verantwortung."
          />
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: 0.15 }}
            data-testid="about-stats"
            className="grid grid-cols-2 gap-x-8 gap-y-8 mt-12"
          >
            {STATS.map((s) => (
              <div key={s.label} className="border-l-2 border-[#e2001a] pl-5">
                <div className="font-display font-bold text-4xl sm:text-5xl text-[#1a1d20]">{s.value}</div>
                <div className="text-[#1a1d20]/55 text-sm mt-1">{s.label}</div>
              </div>
            ))}
          </motion.div>
        </div>

        <div data-testid="team-grid" className="grid grid-cols-2 gap-5">
          {IMAGES.team.map((t, i) => (
            <motion.figure
              key={t.label}
              data-testid={`team-card-${i}`}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.09, ease: [0.22, 1, 0.36, 1] }}
              className={`group relative overflow-hidden rounded-2xl aspect-square ${i % 2 === 1 ? "sm:mt-10" : ""}`}
            >
              <img
                src={t.img}
                alt={t.label}
                loading="lazy"
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.06]"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#14171a]/80 via-transparent to-transparent" />
              <figcaption className="absolute bottom-0 inset-x-0 p-5 font-display font-medium text-white text-sm sm:text-base">
                {t.label}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </div>
  </section>
);
